import type { FC } from 'react';
import { useMemo } from 'react';
import { Card, Stack, styled, Typography } from '@mui/material';
import type { LabelColor } from '@pflegenavi/web-components';
import { Label } from '@pflegenavi/web-components';
import { DirectDebitStatus, PaymentInitiatedBy } from '@pflegenavi/shared/api';
import { useTranslation } from 'react-i18next';
import { renderDirectDebitStatus } from '../dashboard/ResidentCard';

interface DirectDebitStatusCardProps {
  status: DirectDebitStatus;
  paymentInitiation?: PaymentInitiatedBy;
}

export const DirectDebitStatusCard: FC<DirectDebitStatusCardProps> = ({
  status,
  paymentInitiation,
}) => {
  const { t } = useTranslation();

  const labelColor: LabelColor = useMemo(() => {
    if (paymentInitiation === PaymentInitiatedBy.FamilyMember) {
      return 'info';
    }
    if (status === DirectDebitStatus.Active) {
      return 'success';
    }
    if (status === DirectDebitStatus.Pending) {
      return 'warning';
    }
    return 'error';
  }, [status, paymentInitiation]);

  return (
    <RootContainer>
      <InnerContainer sx={{ alignItems: 'center' }} direction="row" spacing={2}>
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          {t('mobile.family-member.current-direct-debit-status')}
        </Typography>
        <Label
          variant="filled"
          color={labelColor}
          sx={{
            color:
              status === DirectDebitStatus.Pending ? 'primary.main' : 'white',
          }}
        >
          {paymentInitiation === PaymentInitiatedBy.FamilyMember
            ? t('direct-debit.status.manual')
            : t(renderDirectDebitStatus(status))}
        </Label>
      </InnerContainer>
    </RootContainer>
  );
};
const RootContainer = styled(Card)(({ theme }) =>
  theme.unstable_sx({
    p: 1,
    width: '100%',
    borderRadius: 3,
  })
);

const InnerContainer = styled(Stack)(({ theme }) =>
  theme.unstable_sx({
    bgcolor: 'grey.200',
    paddingX: 2,
    paddingY: 3,
    borderRadius: 3,
  })
);
